import {ForYouItem} from '../shared/ForYouItem'
import {PendingChecksBody} from './shared/PendingChecksBody'
import {decideChecksItem} from './shared/checks-item-decider'
import {useValidatedChecksData} from './use-validated-checks-data'
import {StatusCheckStatesIcon} from '@github-ui/mergebox/components/sections/checks/StatusCheckStatesIcon'
import {
  accessibleChecksSummary,
  checksSectionHeading,
} from '@github-ui/mergebox/components/sections/checks/checks-section-header-text'

// Renders when checks are still running and no workflow approval is pending
export function PendingChecks() {
  const data = useValidatedChecksData()

  if (!data || decideChecksItem(data).kind !== 'pending') {
    return null
  }

  const {statusRollup, checksSection} = data

  return (
    <ForYouItem
      leadingVisual={<StatusCheckStatesIcon statusRollupSummary={statusRollup.summary} size={16} />}
      title={checksSectionHeading[checksSection.sectionStatus]}
      itemName="pending-checks"
      padding="none"
      description={accessibleChecksSummary(statusRollup.summary)}
    >
      <PendingChecksBody data={data} emptyMessage="No checks have been reported for this pull request yet." />
    </ForYouItem>
  )
}
